var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 18,
    width: 18,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.433.289a1.1 1.1 0 0 0-.866 0l-7.7 3.3a1.1 1.1 0 0 0 0 2.022l2.908 1.247c.106-.12.239-.218.392-.283l4.4-1.886a1.1 1.1 0 1 1 .866 2.022l-3 1.286 2.134.914a1.1 1.1 0 0 0 .866 0l7.7-3.3a1.1 1.1 0 0 0 0-2.022zM1.641 8.336l1.859.797v4.512a9.874 9.874 0 0 0-1.154-.19 1.1 1.1 0 0 1-.98-.98 12.227 12.227 0 0 1 .275-4.139zM8.23 16.23a9.927 9.927 0 0 0-2.53-1.801v-4.353l2 .857a3.3 3.3 0 0 0 2.6 0l6.059-2.597a12.126 12.126 0 0 1 .274 4.139 1.1 1.1 0 0 1-.979.98A9.865 9.865 0 0 0 9.77 16.23a1.1 1.1 0 0 1-1.54 0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.6 17.8a1.1 1.1 0 0 0 1.1-1.1v-2.271a9.825 9.825 0 0 0-2.2-.784V16.7a1.1 1.1 0 0 0 1.1 1.1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCap);
export default __webpack_public_path__ + "static/media/cap.bce75652008c936e63a335139cb13606.svg";
export { ForwardRef as ReactComponent };